__turbopack_context__.v({
  "animate-float": "Home-module__xMJmea__animate-float",
  "animate-float-delayed": "Home-module__xMJmea__animate-float-delayed",
  "centered": "Home-module__xMJmea__centered",
  "float": "Home-module__xMJmea__float",
  "float-delayed": "Home-module__xMJmea__float-delayed",
  "floatBadge1": "Home-module__xMJmea__floatBadge1",
  "floatBadge2": "Home-module__xMJmea__floatBadge2",
  "floatBadge3": "Home-module__xMJmea__floatBadge3",
  "floatBadge4": "Home-module__xMJmea__floatBadge4",
  "heroText": "Home-module__xMJmea__heroText",
  "thumbnailImg": "Home-module__xMJmea__thumbnailImg",
  "welcomeimg": "Home-module__xMJmea__welcomeimg",
  "welcomeimgpc": "Home-module__xMJmea__welcomeimgpc",
  "welcomepc": "Home-module__xMJmea__welcomepc",
});
